import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import { UserStrengthWorkoutService } from 'src/app/services/user-strength-workout.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-move-exercise',
  templateUrl: './move-exercise.component.html',
  styleUrls: ['./move-exercise.component.scss'],
})
export class MoveExerciseComponent implements OnInit {
  level:any;
  isLoading = false;
  next: any;
  prev: any;
  exercises: any;
  exerciseId: any;
  exercise: any;

  exerciseAreas = [
    'Lower Body',
    'Upper Body',
    'Core'
  ];

  levelExercises:any;

  constructor(
    private userStrengthWorkoutService: UserStrengthWorkoutService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.userStrengthWorkoutService
      .fetchExercises()
      .subscribe((responseData) => {
        this.exercises = responseData;
       
        this.isLoading = false;
        // params
        this.route.params.subscribe((params) => {
          this.exerciseId = params.exerciseId;
          this.level = params.level;

          let sessionAExercises = this.userStrengthWorkoutService.getExercisesForSession(this.level,'A',this.exercises);
          let sessionBExercises = this.userStrengthWorkoutService.getExercisesForSession(this.level,'B',this.exercises);
          this.levelExercises = sessionAExercises.concat(sessionBExercises);
          console.log(this.levelExercises);
          
          this.exercises.forEach((_exercise: any) => {
            if (_exercise.strength_exercise_id == this.exerciseId) {
              this.exercise = _exercise;
            }
          });
        });
      });
  }

  getVideo(asset: string) {
    return environment.staticUrl + '/' + asset;
  }



  getExerciseByArea(exercises:any, area:string){

    let filteredExercises:any = [];
    exercises.forEach((exercise:any) => {
      if(exercise.area == area){
        filteredExercises.push(exercise);
      }
    });
    return filteredExercises.filter(this.onlyUnique);;
  }

  onlyUnique(value:any, index:number, array:any) {
    return array.indexOf(value) === index;
  }
}
